// puntosdeventa.component.ts
import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-puntosdeventa',
  templateUrl: './puntosdeventa.component.html',
  styleUrls: ['./puntosdeventa.component.scss']
})
export class PuntosdeventaComponent implements OnInit {
  lugaresPorCiudad = [
    {
      titulo: "Puntos de Venta Puebla",
      color: "#6f5dff",
      lugares: [
        {
          img: "assets/images/puntos-venta/1.jpg",
          titulo_lugar: "Centro comercial Angelopolis",
          direccion: "Blvrd del Niño Poblano 2510, Reserva Territorial Atlixcáyotl, Concepción la Cruz, 72450 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/pZycAszS9h67zqaKA"
        },
        {
          img: "assets/images/puntos-venta/2.jpg",
          titulo_lugar: "PLAZA DORADA",
          direccion: "Blvd. Heroes 5 de Mayo # 3510 C.C. Plaza Dorada, Anzures, 72534 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/tyxgg9aoMXyzofQJA"
        },
        {
          img: "assets/images/puntos-venta/3.jpg",
          titulo_lugar: "PLAZA DORADA",
          direccion: "Centro Comercial Plaza Cristal 72440 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/PTYvG12HQL7oFzHU8"
        },


        {
          img: "assets/images/puntos-venta/4.jpg",
          titulo_lugar: "Cruz del Sur",
          direccion: "Blvd. Forjadores de Puebla 1009, Bello Horizonte, 72700 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/DoJPG3sgeNsx2xuk6"
        },
        {
          img: "assets/images/puntos-venta/5.jpg",
          titulo_lugar: "Plaza San Pedro",
          direccion: "Blvrd Nte 2210, Las Hadas Mundial 86, 72070 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/3RrowfxfCGRGziDQA"
        },
        {
          img: "assets/images/puntos-venta/6.jpg",
          titulo_lugar: "Plaza Loreto",
          direccion: "Centro Comercial Plaza Loreto Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/npCuV4jKjNu2an4j8"
        },


        {
          img: "assets/images/puntos-venta/7.jpg",
          titulo_lugar: "Via San Ángel ",
          direccion: "Atlixcáyotl 1504, Reserva Territorial Atlixcáyotl, Centros Comerciales Desarrollo Atlixcayotl, 72810 San Bernardino xalapancingo, Pue.",
          urlmaps: "https://maps.app.goo.gl/vA9NPjSdhtPVp6Kw6"
        }, {
          img: "assets/images/puntos-venta/8.jpg",
          titulo_lugar: "Centro Comercial La Victoria",
          direccion: "5 de Mayo 409A, Centro histórico de Puebla, 72000 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/hHKQHAd9jAj4pPVj8"
        },
        {
          img: "assets/images/puntos-venta/9.jpg",
          titulo_lugar: "Woolworth",
          direccion: "Av 2 Pte 101, Centro, 72000 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/wDDh7ykVYJaXuhgf6"
        },
        {
          img: "assets/images/puntos-venta/10.jpg",
          titulo_lugar: "Pasaje Ayuntamiento",
          direccion: "7 Pje. del Ayuntamiento Heroica Puebla de Zaragoza, Puebla",
          urlmaps: "https://maps.app.goo.gl/bRat91KTgxCos1cFA"
        },
        {
          img: "assets/images/puntos-venta/11.jpg",
          titulo_lugar: "Sears Centro",
          direccion: "Av 3 Pte 109, Centro histórico de Puebla, 72000 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/kX6cqVepBHYFRykT9"
        },
        {
          img: "assets/images/puntos-venta/12.jpg",
          titulo_lugar: "Nueva España",
          direccion: "5 de Mayo 2, de la Ciudad de México, Centro histórico de Puebla, 72000 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/kX6cqVepBHYFRykT9"
        },
        {
          img: "assets/images/puntos-venta/13.jpg",
          titulo_lugar: "Galerias Serdán",
          direccion: "Blvd. Hermanos Serdán 270, Colonia Rancho, Posadas, 72060 Heroica Puebla de Zaragoza, Pue.",
          urlmaps: "https://maps.app.goo.gl/6VUfovrSTfUN3vEu6"
        },
        {
          img: "assets/images/puntos-venta/14.jpg",
          titulo_lugar: "Plaza América",
          direccion: "Av. Circuito Juan Pablo II - 51 Poniente (carriles derechos), Heroica Puebla de Zaragoza, Puebla, Mexico",
          urlmaps: "https://maps.app.goo.gl/ozwGKteUHfanH2V37"
        },





      ]
    },
    {
      titulo: "Puntos de Venta Tlaxcala",
      color: "#6f5dff",
      lugares: [
        {
          img: "assets/images/puntos-venta/t1.jpg",
          titulo_lugar: "Galerias Tlaxcala",
          direccion: "Libramiento Poniente de xalapa S/N, San Sebastián Atlahapa, 90111 San Sebastián Atlahapa, Tlax.",
          urlmaps: "https://maps.app.goo.gl/FVjBmyVcD9HZHgSj9"
        },

      ]
    },
    {
      titulo: "Puntos de Venta Xalapa",
      color: "#e63020",
      lugares: [
        {
          img: "assets/images/puntos-venta/xalapa1.jpg",
          titulo_lugar: "BACH",
          direccion: "AV. ARAUCARIAS No. 1104 ESQ. JUAN SEBASTIAN BACH, FRACC. INDECO ANIMAS C.P. 91190 XALAPA, VER.",
          urlmaps: "https://www.google.com/maps?q=AV.+ARAUCARIAS+1104+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa2.jpg",
          titulo_lugar: "COATEPEC",
          direccion: "ZARAGOZA #114 ESQ. CAMINO A LAS HACIENDAS COL. CENTRO C.P. 91500 COATEPEC, VER.",
          urlmaps: "https://www.google.com/maps?q=ZARAGOZA+114+Coatepec+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa3.jpg",
          titulo_lugar: "MAESTROS",
          direccion: "AV. MAESTROS VERACRUZANOS #143 LOCALES 4 Y 5 COL. DOS DE ABRIL XALAPA, VER. C.P. 91030",
          urlmaps: "https://www.google.com/maps?q=MAESTROS+VERACRUZANOS+143+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa4.jpg",
          titulo_lugar: "CATEDRAL",
          direccion: "EDIFICIO NACHITA LOCAL 3 AV. ENRIQUEZ S/N ESQ. AV. REVOLUCION ZONA CENTRO C.P. 91000 XALAPA, VER.",
          urlmaps: "https://www.google.com/maps?q=AV.+ENRIQUEZ+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa5.jpg",
          titulo_lugar: "ARAUCARIAS",
          direccion: "ARAUCARIAS No. 102 COL. SAHOP XALAPA, VER. CP. 91190",
          urlmaps: "https://www.google.com/maps?q=ARAUCARIAS+102+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa6.jpg",
          titulo_lugar: "JARDINES",
          direccion: "CALLE JOAQUIN ARRONIZ No. 366-A COL. SIETE DE NOVIEMBRE XALAPA, VER. C.P. 91150",
          urlmaps: "https://www.google.com/maps?q=JOAQUIN+ARRONIZ+366A+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa7.jpg",
          titulo_lugar: "EUROPA",
          direccion: "BLVD. EUROPA No. 96 LOCAL 6 COL. CAÑADA DE LAS ANIMAS C.P.91190 XALAPA, VER.",
          urlmaps: "https://www.google.com/maps?q=BLVD.+EUROPA+96+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa8.jpg",
          titulo_lugar: "XICO",
          direccion: "CALLE MIGUEL HIDALGO No. 02 B ESQ. CALLE EL PINTOR ZONA CENTRO C.P. 91240 XICO, VERACRUZ",
          urlmaps: "https://www.google.com/maps?q=MIGUEL+HIDALGO+2B+Xico+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa9.jpg",
          titulo_lugar: "MONTE MAGNO",
          direccion: "PLAZA MONTE MAGNO LOCAL 1,2 ZONA A BLVD. EUROPA No. 28, ESQ. CALLE HELSINKI, LUXEMBURGO Y ANDORRA, FRACC MONTE MAGNO C.P. 91193 XALAPA, VER.",
          urlmaps: "https://www.google.com/maps?q=PLAZA+MONTE+MAGNO+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa10.jpg",
          titulo_lugar: "LA JOYA",
          direccion: "CARRETERA FEDERAL XALAPA-MEXICO KM 20 LOC. LA JOYA, C.P. 91325 ACAJETE, VERACRUZ",
          urlmaps: "https://www.google.com/maps?q=CARRETERA+XALAPA-MEXICO+KM+20+Acajete+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa11.jpg",
          titulo_lugar: "URBAN",
          direccion: "CALLE DELFINO VALENZUELA No. 201 ESQ. LAZARO CARDENAS COL. RAFAEL LUCIO C.P. 91110 XALAPA, VER.",
          urlmaps: "https://www.google.com/maps?q=DELFINO+VALENZUELA+201+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa12.jpg",
          titulo_lugar: "PRADERA",
          direccion: "AV. PRINCIPAL S/N LOCAL12 PLAZA CARAL FRACC. LA PRADERA C.P. 91637 EMILIANO ZAPATA, VER.",
          urlmaps: "https://www.google.com/maps?q=PLAZA+CARAL+Emiliano+Zapata+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa13.jpg",
          titulo_lugar: "BOSQUES",
          direccion: "AV. RAFAEL MURILLO VIDAL S/N ESQ. RIO JAMAPA COL. CUAUHTÉMOC C.P. 91069 XALAPA, VER.",
          urlmaps: "https://www.google.com/maps?q=RAFAEL+MURILLO+VIDAL+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa14.jpg",
          titulo_lugar: "PEROTE",
          direccion: "AVENIDA ALEJANDRO VON HUMBOLDT SUR No. 3 COL. CENTRO C.P. 91270 MPIO. PEROTE, VERACRUZ",
          urlmaps: "https://www.google.com/maps?q=ALEJANDRO+VON+HUMBOLDT+3+Perote+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa15.jpg",
          titulo_lugar: "SUMIDERO",
          direccion: "AV. CAMINO ANTIGÜO AL SUMIDERO, ESQ. EL CAUDAL S/N COL. LOMAS DE CASA BLANCA C.P. 91164 XALAPA, VERACRUZ",
          urlmaps: "https://www.google.com/maps?q=SUMIDERO+Lomas+de+Casa+Blanca+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa16.jpg",
          titulo_lugar: "LAS VIGAS",
          direccion: "CALLE 16 DE SEPTIEMBRE No.16, ESQ.2 DE ABRIL COL. CENTRO C.P. 91330 MPIO. DE LAS VIGAS DE RAMÍREZ, VERACRUZ",
          urlmaps: "https://www.google.com/maps?q=16+SEPTIEMBRE+16+Las+Vigas+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa17.jpg",
          titulo_lugar: "CINE",
          direccion: "AV. MAXIMINO AVILA CAMACHO No. 212 COL. CENTRO C.P. 93600 MARTINEZ DE LA TORRE, VER",
          urlmaps: "https://www.google.com/maps?q=MAXIMINO+AVILA+CAMACHO+212+Martinez+de+la+Torre+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa18.jpg",
          titulo_lugar: "CARDEL",
          direccion: "AV. FLORES MAGON NORTE No. 47 ESQ. BENITO JUAREZ COL. CENTRO C.P. 91680 CARDEL, VER. EN FRENTE CASI A LA GASERA",
          urlmaps: "https://www.google.com/maps?q=FLORES+MAGON+NORTE+47+Cardel+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa19.jpg",
          titulo_lugar: "PALO GACHO",
          direccion: "CARR FEDERAL XALAPA-VERACRUZ KM. 37.5 PALO GACHO C.P. 91633 MPIO. EMILIANO ZAPATA, VERACRUZ ESTACION PEMEX 11467",
          urlmaps: "https://www.google.com/maps?q=XALAPA-VERACRUZ+PALO+GACHO+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa20.jpg",
          titulo_lugar: "ALTOTONGA",
          direccion: "CALLE ABASOLO No. 56 COL. CENTRO C.P. 93700 MPIO. DE ALTOTONGA, VERACRUZ",
          urlmaps: "https://www.google.com/maps?q=ABASOLO+56+Altotonga+Veracruz"
        },
        // Estos son los estanquillos y plazas:
        {
          img: "assets/images/puntos-venta/xalapa21.jpg",
          titulo_lugar: "Plaza Crystal",
          direccion: "Adentro de Chedraui, Lazaro Cardenas.",
          urlmaps: "https://www.google.com/maps?q=Chedraui+Lazaro+Cardenas+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa22.jpg",
          titulo_lugar: "Plaza las Ánimas",
          direccion: "Enfrente de Chedraui, Av. Lazaro Cardenas",
          urlmaps: "https://www.google.com/maps?q=Plaza+las+Animas+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa23.jpg",
          titulo_lugar: "Plaza las Americas",
          direccion: "Junto al Restaurante Sanborns, Carretera Xalapa, Veracruz",
          urlmaps: "https://www.google.com/maps?q=Plaza+las+Americas+Sanborns+Xalapa+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa24.jpg",
          titulo_lugar: "Walmart de Arcos Sur",
          direccion: "En la Entrada, Av. Arco Sur",
          urlmaps: "https://www.google.com/maps?q=Walmart+Arco+Sur+Xalapa+Veracruz"
        },
        // Estanquillos Coatepec
        {
          img: "assets/images/puntos-venta/xalapa25.jpg",
          titulo_lugar: "Estanquillo Coatepec - Aldana",
          direccion: "Calle Aldana zona centro a costado del Banco Banamex",
          urlmaps: "https://www.google.com/maps?q=Calle+Aldana+Coatepec+Veracruz"
        },
        {
          img: "assets/images/puntos-venta/xalapa26.jpg",
          titulo_lugar: "Estanquillo Coatepec - Miguel Lerdo",
          direccion: "Calle Miguel Lerdo, en frente del mercado Zona Centro",
          urlmaps: "https://www.google.com/maps?q=Miguel+Lerdo+mercado+Coatepec+Veracruz"
        },

      ]

    },
    {
      titulo: "Puntos de Venta Guadalajara",
      color: "#6f5dff",
      lugares: [
        {
          titulo_lugar: "José Guadalupe Ramos Flores",
          direccion: "Victoria 1705, Oficina 9, Col. Providencia, entre calles Toronto y Santa Fe, Guadalajara, C.P. 44630",
          telefono: "8125958301",
          urlmaps: "https://maps.app.goo.gl/nU3fTkFKcTPuB6sW6"
        },
      ]
    },
    {
      titulo: "Puntos de Venta Monterrey",
      color: "#e63020",
      lugares: [
        {
          titulo_lugar: "La Cascada de la Suerte",
          contacto: "C. José Miguel Rodríguez Ponce",
          direccion: "Hidalgo No. 201 Ote., Zona Centro, Monterrey, N.L., C.P. 64000",
          telefono: "83440700",
          urlmaps: "https://maps.app.goo.gl/EHrLhRKUSQzKQfdP9"
        },
      ]
    },
    {
      titulo: "Puntos de Venta Mérida",
      color: "#6f5dff",
      lugares: [
        {
          titulo_lugar: "Proveedora de Expendios",
          contacto: "Héctor Silva Villarreal",
          direccion: "Calle 63 No. 496 x 58 y 60, Centro, Mérida, Yucatán, C.P. 97000",
          telefono: "8127635176",
          urlmaps: "https://maps.app.goo.gl/PDG9SGVQn5qjUNZW7"
        },
      ]
    },
    {
      titulo: "Puntos de Venta Cd. Victoria",
      color: "#e63020",
      lugares: [
        {
          titulo_lugar: "Lourdes Angélica Ponce Arratia",
          direccion: "14 y 15 Miguel Hidalgo No. 368, Zona Centro, Cd. Victoria, Tamps., C.P. 87000",
          telefono: "52 834 146 4509",
          urlmaps: "https://maps.app.goo.gl/tVJv2d5A9VWfnbNS9"
        },
      ]
    }
  ];

  constructor() { }

  ngOnInit(): void {
    this.lugaresPorCiudad.forEach((ciudad: any) => {
      ciudad.lugares.forEach((lugar: any) => {
        // Solo se capitalizan las direcciones capturadas en mayúsculas
        if (lugar.direccion === lugar.direccion.toUpperCase()) {
          lugar.direccion = this.capitalizeText(lugar.direccion);
        }
      });
    });

  }

  formatearDireccion(direccion: string): string {
    return direccion;
  }

  capitalizeText(text) {
    return text.toLowerCase().replace(/(?:^|\s|,|-)\S/g, function (a) {
      return a.toUpperCase();
    });
  }
}
